import { apiFetch } from "./apiFetch";

export interface AuditLog {
	id: string;
	userId: string | null;
	userEmail: string | null;
	action: string;
	resourceType: string | null;
	resourceId: string | null;
	ipAddress: string | null;
	userAgent: string | null;
	status: string;
	errorMessage: string | null;
	metadata: Record<string, any> | null;
	createdAt: string;
}

export interface AuditLogsListResponse {
	logs: AuditLog[];
	total: number;
	page: number;
	limit: number;
	totalPages: number;
}

export interface GetAuditLogsParams {
	page?: number;
	limit?: number;
	action?: string;
	userId?: string;
	resourceType?: string;
	resourceId?: string;
	status?: string;
	from?: string;
	to?: string;
}

export const auditService = {
	getProjectAuditLogs: async (
		projectId: string,
		params: GetAuditLogsParams = {},
	): Promise<AuditLogsListResponse> => {
		const queryParams = new URLSearchParams();
		if (params.page) queryParams.append("page", params.page.toString());
		if (params.limit) queryParams.append("limit", params.limit.toString());
		if (params.action) queryParams.append("action", params.action);
		if (params.userId) queryParams.append("userId", params.userId);
		if (params.resourceType)
			queryParams.append("resourceType", params.resourceType);
		if (params.resourceId) queryParams.append("resourceId", params.resourceId);
		if (params.status) queryParams.append("status", params.status);
		if (params.from) queryParams.append("from", params.from);
		if (params.to) queryParams.append("to", params.to);

		const queryString = queryParams.toString();
		return apiFetch<AuditLogsListResponse>(
			`/projects/${projectId}/audit${queryString ? `?${queryString}` : ""}`,
		);
	},

	getAllAuditLogs: async (
		params: GetAuditLogsParams = {},
	): Promise<AuditLogsListResponse> => {
		const queryParams = new URLSearchParams();
		if (params.page) queryParams.append("page", params.page.toString());
		if (params.limit) queryParams.append("limit", params.limit.toString());
		if (params.action) queryParams.append("action", params.action);
		if (params.userId) queryParams.append("userId", params.userId);
		if (params.resourceType)
			queryParams.append("resourceType", params.resourceType);
		if (params.resourceId) queryParams.append("resourceId", params.resourceId);
		if (params.status) queryParams.append("status", params.status);
		if (params.from) queryParams.append("from", params.from);
		if (params.to) queryParams.append("to", params.to);

		const queryString = queryParams.toString();
		return apiFetch<AuditLogsListResponse>(
			`/audit${queryString ? `?${queryString}` : ""}`,
		);
	},
};
